import MfaSetup from './MfaSetup';

export default MfaSetup;